/**
 * Cognito configuration utilities
 * Shared across member and admin portals
 */

export interface CognitoConfig {
  userPoolId: string
  clientId: string
  region: string
  domain?: string
}

/**
 * Validate Cognito configuration
 * @throws Error if required configuration is missing
 */
export function validateCognitoConfig(config: Partial<CognitoConfig>): CognitoConfig {
  if (!config.userPoolId || !config.clientId || !config.region) {
    throw new Error(
      'Missing required Cognito configuration. Please set userPoolId, clientId, and region.',
    )
  }

  return {
    userPoolId: config.userPoolId,
    clientId: config.clientId,
    region: config.region,
    domain: config.domain,
  }
}
